/**
 * The backend refuses to send an email campaign when the sender is not usable.
 * Both the creation and the draft launch hit that guard, and the two causes
 * are fixed on different screens, so each one gets its own way out.
 */
export default function useEmailDomainGuard() {
  const notification = useNotification()
  const router = useRouter()
  const { t } = useI18n()
  const { isDirection } = useAccess()

  const actionOr = (label: string, onClick: () => void) => (isDirection.value ? { action: { label, onClick } } : {})

  const notifyCampaignError = (error: any, fallbackText: string) => {
    const data = error?.response?.data

    if (data?.code === 'email_settings_missing') {
      notification.create('error', {
        text: data.message,
        persist: true,
        ...actionOr(t('pages.campaignEmail.create.notifications.configureSender'), () =>
          router.push({ name: 'DomainSettings' })
        )
      })

      return
    }

    if (data?.code !== 'email_domain_not_verified') {
      notification.create('error', {
        text: data?.message || fallbackText,
        persist: true
      })

      return
    }

    const domainId = data.domainId

    notification.create('error', {
      text: data.message,
      persist: true,
      ...actionOr(t('pages.campaignEmail.create.notifications.configureDomain'), () =>
        router.push({
          name: 'DomainConfig',
          ...(domainId ? { query: { domainId: String(domainId) } } : {})
        })
      )
    })
  }

  return { notifyCampaignError }
}
